// import { pollBuilderApi } from '../../../../globals';
import { pollResultsJson } from '../../../../globals';
import { constitutionResponse, ConstitutionVoteApi, handleToken } from '../../../api/ConstitutionVote';

// MOCK DATA
import pollData from '../mock/pollData.json';

// import pollResults from '../mock/pollDataResults.json';

export function getPollBuilderMock() {
  return Promise.resolve(pollData);
}

// export function getPollResults() {
//   return Promise.resolve(pollResults);
// }

// REAL DATA
export function getPollResults() {
  return fetch(pollResultsJson)
    .then((response) => response.json())
    .then((data) => data);
}
// export function getPollBuilder() {
//   return fetch(pollBuilderApi)
//     .then((response) => response.json())
//     .then((data) => data);
// }

export async function getUserData() {
  let data;
  let tokenStatus;
  try {
    const result = await ConstitutionVoteApi.getUserResults();
    handleToken(result.tokenStatus);
    return {
      data: result.tokenStatus === constitutionResponse.ALREADY_VOTED ? result.data : null,
      tokenStatus: result.tokenStatus,
    };
  } catch (e) {
    // do nothing
  }

  return {
    data,
    tokenStatus,
  };
}
